import {
  TableContainer,
  TableBody,
  TableCell,
  Table,
  TableRow,
  Grid,
} from "@material-ui/core";
import { PencilIcon, TrashIcon } from "App/Assets";
import {
  TableHeader,
  IconButtonDatatable,
  DatatablesFooter,
  ModalDeleteConfirm,
  MasterButton,
} from "App/Component/ui";
import { useDatatables } from "App/hooks";
import {
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers"; // eslint-disable-line
import React, { useState, useContext } from "react";
import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import { FormContext } from "../context/FormContext";
import { deleteDetailListById, FORM_RESET_DETAIL_PAKET } from "../helpers";
import { headCells } from "../helpers";
import { ModalPaket } from ".";
import { trim } from "lodash";
import { RenderStatusPaket } from "../../DaftarPaketTelekonsul/helpers";
export default function RenderListPaket({
  classes,
  setNewDataPaketList,
  namaInputRef,
}) {
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);
  const { listPaket, formDetail, setFormDetail} = useContext(FormContext);

  const {
    page,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: listPaket,
    orderByDefault: "id_dokter",
    orderByRow: ["id_dokter"],
  });
  const { formData } = useContext(FormContext);
  const { showModaPaket, setShowModaPaket } = useContext(FormContext);

  async function deleteList() {
    const res = await deleteDetailListById(formDetail.id);
    if (res.state) {
      defaultToastSuccess(res?.message);
      setNewDataPaketList(formData.id);
      setShowModalDeleteConfirm(false);
    } else {
      defaultToastError(res?.message);
    }
  }

  const handleClickDelete = (row) => {
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
    setFormDetail({
      ...formDetail,
      id: row?.id,
    });
  };

  const handleClickUpdate = async (row) => {
    await setFormDetail({
      id: row?.id,
      paket_tarif_tele_header_id: row?.paket_tarif_tele_header_id,
      id_dokter: row?.id_dokter,
      dokter: trim(row?.dokter),
      remark: row?.remark,
      onCreate: false,
    });
    namaInputRef?.current?.focus();
    setShowModaPaket(!showModaPaket);
  };

  const handleClickTambah = () => {
    setFormDetail(FORM_RESET_DETAIL_PAKET);
    setShowModaPaket(!showModaPaket);
  };

  return (
    <>
      {showModaPaket && (
        <ModalPaket setNewDataPaketList={setNewDataPaketList} />
      )}
      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => deleteList()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}
      <div className="mb-1">
        <div
          style={{
            display: "flex",
            gap: "0.5rem",
          }}
        >
          {formData.id !== "" && (
            <>
              <p className="fw-600 mr-1">Status : </p>
              <RenderStatusPaket status={formData.status} />
            </>
          )}
        </div>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <h5 className="fw-600">Data Detail Paket</h5>
          <div
            style={{
              display: "flex",
              gap: "10px",
            }}
          >
            <MasterButton
              onClick={() => isNull(formData.id) ? null : handleClickTambah()}
              disabled={isNull(formData.id) ? true : false}
              className={"mt-1"}
              type={"button"}
              color={isNull(formData.id) ? "secondary" : "green"}
              name="Tambah Paket"
              size="md"
            />
          </div>
        </Grid>
      </div>
      <TableContainer className="custom-scrollbar">
        <Table
          className={classes.table}
          aria-labelledby="tableTitle"
          size={"medium"}
          aria-label="enhanced table"
        >
          <TableHeader
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            rowCount={length}
            headCells={headCells}
          />
          <TableBody>
            {stableSort(data, getComparator(order, orderBy))
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                return (
                  <TableRow
                    hover
                    tabIndex={-1}
                    key={index}
                    style={{
                      backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                    }}
                  >
                    <TableCell
                      component="th"
                      scope="row"
                      padding="none"
                      align="center"
                    >
                      {index + 1}
                    </TableCell>

                    <TableCell
                      component="th"
                      scope="row"
                      padding="none"
                      align="center"
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "7px",
                        }}
                      >
                        <IconButtonDatatable
                          onClick={() => handleClickUpdate(row)}
                        >
                          <PencilIcon />
                        </IconButtonDatatable>
                        <IconButtonDatatable
                          onClick={() => handleClickDelete(row)}
                        >
                          <TrashIcon />
                        </IconButtonDatatable>
                      </div>
                    </TableCell>
                    <RenderTableCell row={row} />
                  </TableRow>
                );
              })}
            {listPaket.length === 0 && (
              <TableRow>
                <TableCell align="center" colSpan={headCells.length}>
                  Tidak ada data
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <DatatablesFooter
        page={page}
        length={length}
        rowsPerPage={rowsPerPage}
        selectRows={[10, 20]}
        onPageChange={(page) => setPage(page - 1)}
        onSelectChange={(e) => setRowsPerPage(e.target.value)}
      />
    </>
  );
}

const RenderTableCell = ({ row }) => {
  return (
    <>
      <TableCell align="left">{row?.id}</TableCell>
      <TableCell align="left">{row?.dokter}</TableCell>
      <TableCell align="left">
        {isNull(row?.remark) ? "-" : row?.remark}
      </TableCell>
    </>
  );
};
